export default __webpack_public_path__ + "static/media/1756.998ae5ea.png";